import { ArrowUpRight } from "lucide-react";
import { Link } from "react-router-dom";
import { TROPHY_DETAILS } from "@/data/trophies";

export default function Trophies() {
  return (
    <section
      id="palmares"
      data-testid="trophies-section"
      className="relative py-32 md:py-40 scroll-mt-24"
    >
      <div className="max-w-[1400px] mx-auto px-6 md:px-10 lg:px-16">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-6 mb-16">
          <div>
            <p className="text-[11px] uppercase tracking-[0.3em] text-[#FFB800] mb-6 flex items-center gap-3">
              <span className="h-px w-10 bg-[#FFB800]" />
              05 — Palmarés
            </p>
            <h2 className="font-display text-4xl md:text-6xl lg:text-7xl font-extrabold uppercase tracking-tight leading-[0.95]">
              Títulos<br />
              <span className="italic font-light text-white/70">que pesan.</span>
            </h2>
          </div>
          <Link
            to="/titulos"
            data-testid="trophies-cta"
            className="btn-secondary self-start md:self-end"
          >
            Ver todos los títulos
            <ArrowUpRight size={14} />
          </Link>
        </div>

        <div className="border-t border-white/10">
          {TROPHY_DETAILS.map((t, i) => (
            <Link
              key={t.slug}
              to={`/titulos/${t.slug}`}
              data-testid={`trophy-row-${i}`}
              className="trophy-row group relative flex items-center justify-between py-8 border-b border-white/10 cursor-pointer"
            >
              <div className="flex items-baseline gap-6 md:gap-12 z-10">
                <span className="font-mono text-[11px] tracking-[0.25em] text-white/35 w-16">
                  {t.year}
                </span>
                <div className="flex flex-col">
                  <span className="font-display text-xl md:text-3xl font-bold uppercase tracking-tight text-white group-hover:text-[#FFB800] transition-colors">
                    {t.title}
                  </span>
                  <span className="text-[11px] uppercase tracking-[0.25em] text-white/40 mt-1">
                    {t.cat}
                  </span>
                </div>
              </div>

              {/* Hover image preview */}
              <div className="hidden lg:block absolute right-16 top-1/2 -translate-y-1/2 w-56 aspect-[4/3] overflow-hidden rounded-[1.5rem] opacity-0 group-hover:opacity-100 group-hover:translate-x-0 translate-x-4 transition-all duration-500 pointer-events-none shadow-2xl">
                <img src={t.cover} alt={t.title} className="w-full h-full object-cover" />
                <div className="absolute inset-0 ring-1 ring-[#FFB800]/40 rounded-[1.5rem]" />
              </div>

              <ArrowUpRight
                size={22}
                className="trophy-arrow text-white/40 transition-all duration-300 z-10"
              />
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}
